module.exports = {
  tokenSetOrder: {
    0: {
      value: 'palette',
      type: 'other',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: 'palette',
        type: 'other',
      },
      name: 'TokenSetOrder0',
      attributes: {
        category: 'tokenSetOrder',
        type: '0',
      },
      path: ['tokenSetOrder', '0'],
    },
    1: {
      value: 'semantic',
      type: 'other',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: 'semantic',
        type: 'other',
      },
      name: 'TokenSetOrder1',
      attributes: {
        category: 'tokenSetOrder',
        type: '1',
      },
      path: ['tokenSetOrder', '1'],
    },
  },
  color: {
    text: {
      primary: {
        default: {
          value: '#4d4d4d',
          type: 'color',
          hover: {
            value: '#f5f5f5',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
          },
          description: 'Main text',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#4D4D4D',
            type: 'color',
            hover: {
              value: '{color.gray.100}',
              type: 'color',
              filePath: 'dist/tokens.transformed.json',
              isSource: true,
            },
            description: 'Main text',
          },
          name: 'ColorTextPrimaryDefault',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'primary',
            subitem: 'default',
          },
          path: ['color', 'text', 'primary', 'default'],
        },
        hover: {
          value: '#696969',
          type: 'color',
          hover: {
            value: '#f5f5f5',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
          },
          description: 'Main text hover',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#696969',
            type: 'color',
            hover: {
              value: '{color.gray.100}',
              type: 'color',
              filePath: 'dist/tokens.transformed.json',
              isSource: true,
            },
            description: 'Main text hover',
          },
          name: 'ColorTextPrimaryHover',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'primary',
            subitem: 'hover',
          },
          path: ['color', 'text', 'primary', 'hover'],
        },
        visited: {
          value: '#888888',
          type: 'color',
          hover: {
            value: '#f5f5f5',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
          },
          description: 'Main text visited',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#888888',
            type: 'color',
            hover: {
              value: '{color.gray.100}',
              type: 'color',
              filePath: 'dist/tokens.transformed.json',
              isSource: true,
            },
            description: 'Main text visited',
          },
          name: 'ColorTextPrimaryVisited',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'primary',
            subitem: 'visited',
          },
          path: ['color', 'text', 'primary', 'visited'],
        },
      },
      secondary: {
        default: {
          value: '#696969',
          type: 'color',
          description: 'Sub text but still enough contrast',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#696969',
            type: 'color',
            description: 'Sub text but still enough contrast',
          },
          name: 'ColorTextSecondaryDefault',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'secondary',
            subitem: 'default',
          },
          path: ['color', 'text', 'secondary', 'default'],
        },
        hover: {
          value: '#4d4d4d',
          type: 'color',
          description: 'Sub text hover',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#4D4D4D',
            type: 'color',
            description: 'Sub text hover',
          },
          name: 'ColorTextSecondaryHover',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'secondary',
            subitem: 'hover',
          },
          path: ['color', 'text', 'secondary', 'hover'],
        },
        visited: {
          value: '#888888',
          type: 'color',
          description: 'Sub text visited',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#888888',
            type: 'color',
            description: 'Sub text visited',
          },
          name: 'ColorTextSecondaryVisited',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'secondary',
            subitem: 'visited',
          },
          path: ['color', 'text', 'secondary', 'visited'],
        },
      },
      tertiary: {
        default: {
          value: '#888888',
          type: 'color',
          description: 'Date, not important info, unselected tab text',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#888888',
            type: 'color',
            description: 'Date, not important info, unselected tab text',
          },
          name: 'ColorTextTertiaryDefault',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'tertiary',
            subitem: 'default',
          },
          path: ['color', 'text', 'tertiary', 'default'],
        },
        hover: {
          value: '#696969',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#696969',
            type: 'color',
          },
          name: 'ColorTextTertiaryHover',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'tertiary',
            subitem: 'hover',
          },
          path: ['color', 'text', 'tertiary', 'hover'],
        },
      },
      brand: {
        default: {
          value: '#327ac2',
          type: 'color',
          description: 'Link text',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#327AC2',
            type: 'color',
            description: 'Link text',
          },
          name: 'ColorTextBrandDefault',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'brand',
            subitem: 'default',
          },
          path: ['color', 'text', 'brand', 'default'],
        },
        hover: {
          value: '#286199',
          type: 'color',
          description: 'Link text hover',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#286199',
            type: 'color',
            description: 'Link text hover',
          },
          name: 'ColorTextBrandHover',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'brand',
            subitem: 'hover',
          },
          path: ['color', 'text', 'brand', 'hover'],
        },
        visited: {
          value: '#5d9ad5',
          type: 'color',
          description: 'Link text visited',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#5D9AD5',
            type: 'color',
            description: 'Link text visited',
          },
          name: 'ColorTextBrandVisited',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'brand',
            subitem: 'visited',
          },
          path: ['color', 'text', 'brand', 'visited'],
        },
      },
      alert: {
        default: {
          value: '#e63c74',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#E63C74',
            type: 'color',
          },
          name: 'ColorTextAlertDefault',
          attributes: {
            category: 'color',
            type: 'text',
            item: 'alert',
            subitem: 'default',
          },
          path: ['color', 'text', 'alert', 'default'],
        },
      },
      disabled: {
        value: '#bdbdbd',
        type: 'color',
        description: 'Disabled text',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#BDBDBD',
          type: 'color',
          description: 'Disabled text',
        },
        name: 'ColorTextDisabled',
        attributes: {
          category: 'color',
          type: 'text',
          item: 'disabled',
        },
        path: ['color', 'text', 'disabled'],
      },
      placeholder: {
        value: '#a3a3a3',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#A3A3A3',
          type: 'color',
        },
        name: 'ColorTextPlaceholder',
        attributes: {
          category: 'color',
          type: 'text',
          item: 'placeholder',
        },
        path: ['color', 'text', 'placeholder'],
      },
      unselected: {
        value: '#a3a3a3',
        type: 'color',
        description: 'Unselected tab text',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#A3A3A3',
          type: 'color',
          description: 'Unselected tab text',
        },
        name: 'ColorTextUnselected',
        attributes: {
          category: 'color',
          type: 'text',
          item: 'unselected',
        },
        path: ['color', 'text', 'unselected'],
      },
      inverse: {
        value: '#ffffff',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#FFFFFF',
          type: 'color',
        },
        name: 'ColorTextInverse',
        attributes: {
          category: 'color',
          type: 'text',
          item: 'inverse',
        },
        path: ['color', 'text', 'inverse'],
      },
    },
    bg: {
      primary: {
        default: {
          value: '#ffffff',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#FFFFFF',
            type: 'color',
          },
          name: 'ColorBgPrimaryDefault',
          attributes: {
            category: 'color',
            type: 'bg',
            item: 'primary',
            subitem: 'default',
          },
          path: ['color', 'bg', 'primary', 'default'],
        },
        hover: {
          value: '#fafafa',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#FAFAFA',
            type: 'color',
          },
          name: 'ColorBgPrimaryHover',
          attributes: {
            category: 'color',
            type: 'bg',
            item: 'primary',
            subitem: 'hover',
          },
          path: ['color', 'bg', 'primary', 'hover'],
        },
      },
      secondary: {
        default: {
          value: '#fafafa',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#FAFAFA',
            type: 'color',
          },
          name: 'ColorBgSecondaryDefault',
          attributes: {
            category: 'color',
            type: 'bg',
            item: 'secondary',
            subitem: 'default',
          },
          path: ['color', 'bg', 'secondary', 'default'],
        },
        hover: {
          value: '#f5f5f5',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#F5F5F5',
            type: 'color',
          },
          name: 'ColorBgSecondaryHover',
          attributes: {
            category: 'color',
            type: 'bg',
            item: 'secondary',
            subitem: 'hover',
          },
          path: ['color', 'bg', 'secondary', 'hover'],
        },
      },
      brand: {
        primary: {
          default: {
            value: '#327ac2',
            type: 'color',
            description: 'Primary button background',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#327AC2',
              type: 'color',
              description: 'Primary button background',
            },
            name: 'ColorBgBrandPrimaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'brand',
              subitem: 'primary',
              state: 'default',
            },
            path: ['color', 'bg', 'brand', 'primary', 'default'],
          },
          hover: {
            value: '#286199',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#286199',
              type: 'color',
            },
            name: 'ColorBgBrandPrimaryHover',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'brand',
              subitem: 'primary',
              state: 'hover',
            },
            path: ['color', 'bg', 'brand', 'primary', 'hover'],
          },
        },
        secondary: {
          default: {
            value: '#f7f9fc',
            type: 'color',
            description: 'Important notification bg, Folder selected bg',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#F7F9FC',
              type: 'color',
              description: 'Important notification bg, Folder selected bg',
            },
            name: 'ColorBgBrandSecondaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'brand',
              subitem: 'secondary',
              state: 'default',
            },
            path: ['color', 'bg', 'brand', 'secondary', 'default'],
          },
        },
        cover: {
          default: {
            value: '#212e3b',
            type: 'color',
            description: 'Profile cover default',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#212E3B',
              type: 'color',
              description: 'Profile cover default',
            },
            name: 'ColorBgBrandCoverDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'brand',
              subitem: 'cover',
              state: 'default',
            },
            path: ['color', 'bg', 'brand', 'cover', 'default'],
          },
        },
        empty: {
          default: {
            value: '#dbe5f0',
            type: 'color',
            description: 'Default empty image',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#DBE5F0',
              type: 'color',
              description: 'Default empty image',
            },
            name: 'ColorBgBrandEmptyDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'brand',
              subitem: 'empty',
              state: 'default',
            },
            path: ['color', 'bg', 'brand', 'empty', 'default'],
          },
        },
      },
      success: {
        primary: {
          default: {
            value: '#3da884',
            type: 'color',
            description: 'Toast success background',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#3DA884',
              type: 'color',
              description: 'Toast success background',
            },
            name: 'ColorBgSuccessPrimaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'success',
              subitem: 'primary',
              state: 'default',
            },
            path: ['color', 'bg', 'success', 'primary', 'default'],
          },
          hover: {
            value: '#2f8367',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#2F8367',
              type: 'color',
            },
            name: 'ColorBgSuccessPrimaryHover',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'success',
              subitem: 'primary',
              state: 'hover',
            },
            path: ['color', 'bg', 'success', 'primary', 'hover'],
          },
        },
        secondary: {
          default: {
            value: '#ecf8f4',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#ECF8F4',
              type: 'color',
            },
            name: 'ColorBgSuccessSecondaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'success',
              subitem: 'secondary',
              state: 'default',
            },
            path: ['color', 'bg', 'success', 'secondary', 'default'],
          },
        },
      },
      warning: {
        primary: {
          default: {
            value: '#f5af22',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#F5AF22',
              type: 'color',
            },
            name: 'ColorBgWarningPrimaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'warning',
              subitem: 'primary',
              state: 'default',
            },
            path: ['color', 'bg', 'warning', 'primary', 'default'],
          },
          hover: {
            value: '#da950a',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#DA950A',
              type: 'color',
            },
            name: 'ColorBgWarningPrimaryHover',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'warning',
              subitem: 'primary',
              state: 'hover',
            },
            path: ['color', 'bg', 'warning', 'primary', 'hover'],
          },
        },
        secondary: {
          default: {
            value: '#fefbf5',
            type: 'color',
            description: 'Warning notification bg',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#FEFBF5',
              type: 'color',
              description: 'Warning notification bg',
            },
            name: 'ColorBgWarningSecondaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'warning',
              subitem: 'secondary',
              state: 'default',
            },
            path: ['color', 'bg', 'warning', 'secondary', 'default'],
          },
        },
      },
      alert: {
        primary: {
          default: {
            value: '#e63c74',
            type: 'color',
            description: 'Toast error background',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#E63C74',
              type: 'color',
              description: 'Toast error background',
            },
            name: 'ColorBgAlertPrimaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'alert',
              subitem: 'primary',
              state: 'default',
            },
            path: ['color', 'bg', 'alert', 'primary', 'default'],
          },
          hover: {
            value: '#e63c74',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#E63C74',
              type: 'color',
            },
            name: 'ColorBgAlertPrimaryHover',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'alert',
              subitem: 'primary',
              state: 'hover',
            },
            path: ['color', 'bg', 'alert', 'primary', 'hover'],
          },
        },
        secondary: {
          default: {
            value: '#fdf1f5',
            type: 'color',
            filePath: 'dist/tokens.transformed.json',
            isSource: true,
            original: {
              value: '#FDF1F5',
              type: 'color',
            },
            name: 'ColorBgAlertSecondaryDefault',
            attributes: {
              category: 'color',
              type: 'bg',
              item: 'alert',
              subitem: 'secondary',
              state: 'default',
            },
            path: ['color', 'bg', 'alert', 'secondary', 'default'],
          },
        },
      },
      tertiary: {
        default: {
          value: '#f5f5f5',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#F5F5F5',
            type: 'color',
          },
          name: 'ColorBgTertiaryDefault',
          attributes: {
            category: 'color',
            type: 'bg',
            item: 'tertiary',
            subitem: 'default',
          },
          path: ['color', 'bg', 'tertiary', 'default'],
        },
        hover: {
          value: '#f0f0f0',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#F0F0F0',
            type: 'color',
          },
          name: 'ColorBgTertiaryHover',
          attributes: {
            category: 'color',
            type: 'bg',
            item: 'tertiary',
            subitem: 'hover',
          },
          path: ['color', 'bg', 'tertiary', 'hover'],
        },
      },
      code: {
        value: '#f9f8f5',
        type: 'color',
        description: 'code background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F9F8F5',
          type: 'color',
          description: 'code background',
        },
        name: 'ColorBgCode',
        attributes: {
          category: 'color',
          type: 'bg',
          item: 'code',
        },
        path: ['color', 'bg', 'code'],
      },
      tooltip: {
        value: '#4d4d4d',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#4D4D4D',
          type: 'color',
        },
        name: 'ColorBgTooltip',
        attributes: {
          category: 'color',
          type: 'bg',
          item: 'tooltip',
        },
        path: ['color', 'bg', 'tooltip'],
      },
      overlay: {
        value: '#000000',
        type: 'color',
        description: 'Overlay',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#000000b3',
          type: 'color',
          description: 'Overlay',
        },
        name: 'ColorBgOverlay',
        attributes: {
          category: 'color',
          type: 'bg',
          item: 'overlay',
        },
        path: ['color', 'bg', 'overlay'],
      },
    },
    border: {
      primary: {
        value: '#e6e6e6',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#E6E6E6',
          type: 'color',
        },
        name: 'ColorBorderPrimary',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'primary',
        },
        path: ['color', 'border', 'primary'],
      },
      secondary: {
        value: '#f0f0f0',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F0F0F0',
          type: 'color',
        },
        name: 'ColorBorderSecondary',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'secondary',
        },
        path: ['color', 'border', 'secondary'],
      },
      tertiary: {
        value: '#f5f5f5',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F5F5F5',
          type: 'color',
        },
        name: 'ColorBorderTertiary',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'tertiary',
        },
        path: ['color', 'border', 'tertiary'],
      },
      brand: {
        value: '#327ac2',
        type: 'color',
        description: 'Outline buttons, Notification border, Input selected',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#327AC2',
          type: 'color',
          description: 'Outline buttons, Notification border, Input selected',
        },
        name: 'ColorBorderBrand',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'brand',
        },
        path: ['color', 'border', 'brand'],
      },
      success: {
        value: '#3da884',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#3DA884',
          type: 'color',
        },
        name: 'ColorBorderSuccess',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'success',
        },
        path: ['color', 'border', 'success'],
      },
      warning: {
        value: '#f5af22',
        type: 'color',
        description: 'Warning notification border',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F5AF22',
          type: 'color',
          description: 'Warning notification border',
        },
        name: 'ColorBorderWarning',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'warning',
        },
        path: ['color', 'border', 'warning'],
      },
      alert: {
        value: '#e63c74',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#E63C74',
          type: 'color',
        },
        name: 'ColorBorderAlert',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'alert',
        },
        path: ['color', 'border', 'alert'],
      },
      code: {
        value: '#eeede7',
        type: 'color',
        description: 'code border, code block heading',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#EEEDE7',
          type: 'color',
          description: 'code border, code block heading',
        },
        name: 'ColorBorderCode',
        attributes: {
          category: 'color',
          type: 'border',
          item: 'code',
        },
        path: ['color', 'border', 'code'],
      },
    },
    symbol: {
      primary: {
        default: {
          value: '#a3a3a3',
          type: 'color',
          description: 'Default symbol color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#A3A3A3',
            type: 'color',
            description: 'Default symbol color',
          },
          name: 'ColorSymbolPrimaryDefault',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'primary',
            subitem: 'default',
          },
          path: ['color', 'symbol', 'primary', 'default'],
        },
        hover: {
          value: '#888888',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#888888',
            type: 'color',
          },
          name: 'ColorSymbolPrimaryHover',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'primary',
            subitem: 'hover',
          },
          path: ['color', 'symbol', 'primary', 'hover'],
        },
      },
      brand: {
        default: {
          value: '#327ac2',
          type: 'color',
          description: 'Active symbol, Link button symbol',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#327AC2',
            type: 'color',
            description: 'Active symbol, Link button symbol',
          },
          name: 'ColorSymbolBrandDefault',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'brand',
            subitem: 'default',
          },
          path: ['color', 'symbol', 'brand', 'default'],
        },
        hover: {
          value: '#286199',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#286199',
            type: 'color',
          },
          name: 'ColorSymbolBrandHover',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'brand',
            subitem: 'hover',
          },
          path: ['color', 'symbol', 'brand', 'hover'],
        },
      },
      icon: {
        green: {
          value: '#3da884',
          type: 'color',
          description: 'Folder icon',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#3DA884',
            type: 'color',
            description: 'Folder icon',
          },
          name: 'ColorSymbolIconGreen',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'icon',
            subitem: 'green',
          },
          path: ['color', 'symbol', 'icon', 'green'],
        },
        blue: {
          value: '#327ac2',
          type: 'color',
          description: 'File icon',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#327AC2',
            type: 'color',
            description: 'File icon',
          },
          name: 'ColorSymbolIconBlue',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'icon',
            subitem: 'blue',
          },
          path: ['color', 'symbol', 'icon', 'blue'],
        },
      },
      secondary: {
        default: {
          value: '#4d4d4d',
          type: 'color',
          description:
            'Stronger functional symbols which have to have enough contrast\nex. rich-text-editor icons, fullWidth button etc',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#4D4D4D',
            type: 'color',
            description:
              'Stronger functional symbols which have to have enough contrast\nex. rich-text-editor icons, fullWidth button etc',
          },
          name: 'ColorSymbolSecondaryDefault',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'secondary',
            subitem: 'default',
          },
          path: ['color', 'symbol', 'secondary', 'default'],
        },
        hover: {
          value: '#696969',
          type: 'color',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#696969',
            type: 'color',
          },
          name: 'ColorSymbolSecondaryHover',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'secondary',
            subitem: 'hover',
          },
          path: ['color', 'symbol', 'secondary', 'hover'],
        },
      },
      tertiary: {
        default: {
          value: '#888888',
          type: 'color',
          description: 'Middle level symbols etc. close button, down arrow, lock icon',
          filePath: 'dist/tokens.transformed.json',
          isSource: true,
          original: {
            value: '#888888',
            type: 'color',
            description: 'Middle level symbols etc. close button, down arrow, lock icon',
          },
          name: 'ColorSymbolTertiaryDefault',
          attributes: {
            category: 'color',
            type: 'symbol',
            item: 'tertiary',
            subitem: 'default',
          },
          path: ['color', 'symbol', 'tertiary', 'default'],
        },
      },
      inverse: {
        value: '#ffffff',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#FFFFFF',
          type: 'color',
        },
        name: 'ColorSymbolInverse',
        attributes: {
          category: 'color',
          type: 'symbol',
          item: 'inverse',
        },
        path: ['color', 'symbol', 'inverse'],
      },
      success: {
        value: '#3da884',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#3DA884',
          type: 'color',
        },
        name: 'ColorSymbolSuccess',
        attributes: {
          category: 'color',
          type: 'symbol',
          item: 'success',
        },
        path: ['color', 'symbol', 'success'],
      },
      warning: {
        value: '#f5af22',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F5AF22',
          type: 'color',
        },
        name: 'ColorSymbolWarning',
        attributes: {
          category: 'color',
          type: 'symbol',
          item: 'warning',
        },
        path: ['color', 'symbol', 'warning'],
      },
      alert: {
        value: '#e63c74',
        type: 'color',
        description: 'Notification badge',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#E63C74',
          type: 'color',
          description: 'Notification badge',
        },
        name: 'ColorSymbolAlert',
        attributes: {
          category: 'color',
          type: 'symbol',
          item: 'alert',
        },
        path: ['color', 'symbol', 'alert'],
      },
    },
    gray: {
      50: {
        value: '#fafafa',
        type: 'color',
        description: 'Light gray background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#FAFAFA',
          type: 'color',
          description: 'Light gray background',
        },
        name: 'ColorGray50',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '50',
        },
        path: ['color', 'gray', '50'],
      },
      100: {
        value: '#f5f5f5',
        type: 'color',
        description: 'Disabled background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F5F5F5',
          type: 'color',
          description: 'Disabled background',
        },
        name: 'ColorGray100',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '100',
        },
        path: ['color', 'gray', '100'],
      },
      200: {
        value: '#f0f0f0',
        type: 'color',
        description: 'Editor head border',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F0F0F0',
          type: 'color',
          description: 'Editor head border',
        },
        name: 'ColorGray200',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '200',
        },
        path: ['color', 'gray', '200'],
      },
      300: {
        value: '#e6e6e6',
        type: 'color',
        description: 'Default border',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#E6E6E6',
          type: 'color',
          description: 'Default border',
        },
        name: 'ColorGray300',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '300',
        },
        path: ['color', 'gray', '300'],
      },
      400: {
        value: '#d3d3d3',
        type: 'color',
        description: 'Not applied any component yet',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#D3D3D3',
          type: 'color',
          description: 'Not applied any component yet',
        },
        name: 'ColorGray400',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '400',
        },
        path: ['color', 'gray', '400'],
      },
      500: {
        value: '#bdbdbd',
        type: 'color',
        description: 'Disabled text',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#BDBDBD',
          type: 'color',
          description: 'Disabled text',
        },
        name: 'ColorGray500',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '500',
        },
        path: ['color', 'gray', '500'],
      },
      600: {
        value: '#a3a3a3',
        type: 'color',
        description: 'Icon primary color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#A3A3A3',
          type: 'color',
          description: 'Icon primary color',
        },
        name: 'ColorGray600',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '600',
        },
        path: ['color', 'gray', '600'],
      },
      700: {
        value: '#888888',
        type: 'color',
        description: 'Tertiary text',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#888888',
          type: 'color',
          description: 'Tertiary text',
        },
        name: 'ColorGray700',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '700',
        },
        path: ['color', 'gray', '700'],
      },
      800: {
        value: '#696969',
        type: 'color',
        description: 'Secondary text',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#696969',
          type: 'color',
          description: 'Secondary text',
        },
        name: 'ColorGray800',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '800',
        },
        path: ['color', 'gray', '800'],
      },
      900: {
        value: '#4d4d4d',
        type: 'color',
        description: 'Primary text',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#4D4D4D',
          type: 'color',
          description: 'Primary text',
        },
        name: 'ColorGray900',
        attributes: {
          category: 'color',
          type: 'gray',
          item: '900',
        },
        path: ['color', 'gray', '900'],
      },
    },
    blue: {
      50: {
        value: '#f7f9fc',
        type: 'color',
        description: 'Folder selected',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F7F9FC',
          type: 'color',
          description: 'Folder selected',
        },
        name: 'ColorBlue50',
        attributes: {
          category: 'color',
          type: 'blue',
          item: '50',
        },
        path: ['color', 'blue', '50'],
      },
      200: {
        value: '#dbe5f0',
        type: 'color',
        description: 'Default image background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#DBE5F0',
          type: 'color',
          description: 'Default image background',
        },
        name: 'ColorBlue200',
        attributes: {
          category: 'color',
          type: 'blue',
          item: '200',
        },
        path: ['color', 'blue', '200'],
      },
      500: {
        value: '#5d9ad5',
        type: 'color',
        description: 'Blue visited',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#5D9AD5',
          type: 'color',
          description: 'Blue visited',
        },
        name: 'ColorBlue500',
        attributes: {
          category: 'color',
          type: 'blue',
          item: '500',
        },
        path: ['color', 'blue', '500'],
      },
      600: {
        value: '#327ac2',
        type: 'color',
        description: 'Brand color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#327AC2',
          type: 'color',
          description: 'Brand color',
        },
        name: 'ColorBlue600',
        attributes: {
          category: 'color',
          type: 'blue',
          item: '600',
        },
        path: ['color', 'blue', '600'],
      },
      700: {
        value: '#286199',
        type: 'color',
        description: 'Blue hover',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#286199',
          type: 'color',
          description: 'Blue hover',
        },
        name: 'ColorBlue700',
        attributes: {
          category: 'color',
          type: 'blue',
          item: '700',
        },
        path: ['color', 'blue', '700'],
      },
      900: {
        value: '#212e3b',
        type: 'color',
        description: 'Default profile cover',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#212E3B',
          type: 'color',
          description: 'Default profile cover',
        },
        name: 'ColorBlue900',
        attributes: {
          category: 'color',
          type: 'blue',
          item: '900',
        },
        path: ['color', 'blue', '900'],
      },
    },
    pink: {
      100: {
        value: '#fdf1f5',
        type: 'color',
        description: 'Conflict delete, error background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#FDF1F5',
          type: 'color',
          description: 'Conflict delete, error background',
        },
        name: 'ColorPink100',
        attributes: {
          category: 'color',
          type: 'pink',
          item: '100',
        },
        path: ['color', 'pink', '100'],
      },
      400: {
        value: '#f089ab',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F089AB',
          type: 'color',
        },
        name: 'ColorPink400',
        attributes: {
          category: 'color',
          type: 'pink',
          item: '400',
        },
        path: ['color', 'pink', '400'],
      },
      600: {
        value: '#e63c74',
        type: 'color',
        description: 'Danger',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#E63C74',
          type: 'color',
          description: 'Danger',
        },
        name: 'ColorPink600',
        attributes: {
          category: 'color',
          type: 'pink',
          item: '600',
        },
        path: ['color', 'pink', '600'],
      },
      700: {
        value: '#e63c74',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#E63C74',
          type: 'color',
        },
        name: 'ColorPink700',
        attributes: {
          category: 'color',
          type: 'pink',
          item: '700',
        },
        path: ['color', 'pink', '700'],
      },
    },
    yellow: {
      100: {
        value: '#fefbf5',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#FEFBF5',
          type: 'color',
        },
        name: 'ColorYellow100',
        attributes: {
          category: 'color',
          type: 'yellow',
          item: '100',
        },
        path: ['color', 'yellow', '100'],
      },
      300: {
        value: '#f9cd75',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F9CD75',
          type: 'color',
        },
        name: 'ColorYellow300',
        attributes: {
          category: 'color',
          type: 'yellow',
          item: '300',
        },
        path: ['color', 'yellow', '300'],
      },
      500: {
        value: '#f5af22',
        type: 'color',
        description: 'Warning',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F5AF22',
          type: 'color',
          description: 'Warning',
        },
        name: 'ColorYellow500',
        attributes: {
          category: 'color',
          type: 'yellow',
          item: '500',
        },
        path: ['color', 'yellow', '500'],
      },
      700: {
        value: '#da950a',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#DA950A',
          type: 'color',
        },
        name: 'ColorYellow700',
        attributes: {
          category: 'color',
          type: 'yellow',
          item: '700',
        },
        path: ['color', 'yellow', '700'],
      },
    },
    green: {
      100: {
        value: '#ecf8f4',
        type: 'color',
        description: 'Conflict insert, success background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#ECF8F4',
          type: 'color',
          description: 'Conflict insert, success background',
        },
        name: 'ColorGreen100',
        attributes: {
          category: 'color',
          type: 'green',
          item: '100',
        },
        path: ['color', 'green', '100'],
      },
      400: {
        value: '#70cbad',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#70CBAD',
          type: 'color',
        },
        name: 'ColorGreen400',
        attributes: {
          category: 'color',
          type: 'green',
          item: '400',
        },
        path: ['color', 'green', '400'],
      },
      600: {
        value: '#3da884',
        type: 'color',
        description: 'Success',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#3DA884',
          type: 'color',
          description: 'Success',
        },
        name: 'ColorGreen600',
        attributes: {
          category: 'color',
          type: 'green',
          item: '600',
        },
        path: ['color', 'green', '600'],
      },
      700: {
        value: '#2f8367',
        type: 'color',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#2F8367',
          type: 'color',
        },
        name: 'ColorGreen700',
        attributes: {
          category: 'color',
          type: 'green',
          item: '700',
        },
        path: ['color', 'green', '700'],
      },
    },
    beige: {
      100: {
        value: '#f9f8f5',
        type: 'color',
        description: 'Code background',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#F9F8F5',
          type: 'color',
          description: 'Code background',
        },
        name: 'ColorBeige100',
        attributes: {
          category: 'color',
          type: 'beige',
          item: '100',
        },
        path: ['color', 'beige', '100'],
      },
      200: {
        value: '#eeede7',
        type: 'color',
        description: 'Code border, heading border',
        filePath: 'dist/tokens.transformed.json',
        isSource: true,
        original: {
          value: '#EEEDE7',
          type: 'color',
          description: 'Code border, heading border',
        },
        name: 'ColorBeige200',
        attributes: {
          category: 'color',
          type: 'beige',
          item: '200',
        },
        path: ['color', 'beige', '200'],
      },
    },
    black: {
      value: '#000000',
      type: 'color',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: '#000000',
        type: 'color',
      },
      name: 'ColorBlack',
      attributes: {
        category: 'color',
        type: 'black',
      },
      path: ['color', 'black'],
    },
    white: {
      value: '#ffffff',
      type: 'color',
      description: 'Primary background',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: '#FFFFFF',
        type: 'color',
        description: 'Primary background',
      },
      name: 'ColorWhite',
      attributes: {
        category: 'color',
        type: 'white',
      },
      path: ['color', 'white'],
    },
  },
  opacity: {
    30: {
      value: 0.3,
      type: 'opacity',
      description: 'Headnote, disabled editor icon',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: 0.3,
        type: 'opacity',
        description: 'Headnote, disabled editor icon',
      },
      name: 'Opacity30',
      attributes: {
        category: 'opacity',
        type: '30',
      },
      path: ['opacity', '30'],
    },
    50: {
      value: 0.5,
      type: 'opacity',
      description: 'Disabled button',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: 0.5,
        type: 'opacity',
        description: 'Disabled button',
      },
      name: 'Opacity50',
      attributes: {
        category: 'opacity',
        type: '50',
      },
      path: ['opacity', '50'],
    },
    60: {
      value: 0.6,
      type: 'opacity',
      description: 'Member role',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: 0.6,
        type: 'opacity',
        description: 'Member role',
      },
      name: 'Opacity60',
      attributes: {
        category: 'opacity',
        type: '60',
      },
      path: ['opacity', '60'],
    },
    70: {
      value: 0.7,
      type: 'opacity',
      description: 'Overlay',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: 0.7,
        type: 'opacity',
        description: 'Overlay',
      },
      name: 'Opacity70',
      attributes: {
        category: 'opacity',
        type: '70',
      },
      path: ['opacity', '70'],
    },
  },
  borderRadius: {
    primary: {
      value: '4px',
      type: 'borderRadius',
      filePath: 'dist/tokens.transformed.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'borderRadius',
      },
      name: 'BorderRadiusPrimary',
      attributes: {
        category: 'borderRadius',
        type: 'primary',
      },
      path: ['borderRadius', 'primary'],
    },
  },
}
